<template>
<section class="login-container">
    <div class="bg-wrap" :style="{backgroundImage:`url(${login_img})`}">
        <div class="card-wrap">
        <Card style="width:350px" :dis-hover="true">
            <p slot="title">
                <Icon type="log-in"></Icon>
                欢迎登录
            </p>
            <Form ref="userForm" :model="userForm" :rules="ruleCustom" @keyup.enter.native="btn_login">
                <FormItem prop="username">
                    <Input v-model.trim="userForm.username" :autofocus="true" placeholder="请输入" size="large">
                        <Icon type="ios-person-outline" slot="prepend" class="icon-cls"></Icon>
                    </Input>
                </FormItem>
                <FormItem prop="password">
                    <Input type="password" v-model.trim="userForm.password" placeholder="请输入密码" size="large">
                        <Icon type="ios-lock-outline" slot="prepend"  class="icon-cls"></Icon>
                    </Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="btn_login" long :loading="login_loading">登录</Button>
                </FormItem>
            </Form>
        </Card>
    </div>
        <div style="position: absolute;bottom: 10px;text-align: center;width: 100%">
            <a style="color: white" href="https://beian.miit.gov.cn" target="_blank">琼ICP备2022000793号-4</a></div>
    </div>
</section>
</template>

<script>

export default {
    data(){
        return {
            login_loading:false,
            login_img:require("@/assets/login-bg.jpg"),
            userForm:{
                username:'',
                password:''
            },
            ruleCustom: {
                username: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        btn_login(){
            this.login_loading = true
            this.$http.post('system/login',{
                loginName:this.userForm.username,
                password:this.userForm.password
            }).then(function (res) {
                this.login_loading = false
                let msg = res.body
                if (msg.success) {
                    console.log(msg.data)
                  this.$Notice.success({title: '登陆成功'});
                    sessionStorage.setItem('currentUser', JSON.stringify(msg.data))
                  this.$store.commit('setSystemUser',msg.data)
                  // if (msg.data.role.length > 1) {
                  //   this.$router.replace('/doctor_manage')
                  // } else if (msg.data.role[0] === '医助') {
                  //   this.$router.replace('/doctor_manage')
                  // }else if (msg.data.role[0] === '后台') {
                  //   this.$router.replace('/home')
                  // }
                  let doctor = false;
                  msg.data.role.forEach(item => {
                    if(item === '医助') {
                      doctor = true;
                    }
                  });
                  if(doctor) {
                    this.$router.replace('/doctor_manage')
                  } else {
                    this.$router.replace('/home')
                  }
                }else {
                    this.$Notice.error({title:'登陆失败',desc: `<p>账号或密码输入错误</p><p>Your account or password mismatched, please input again</p>`});
                }
            },function (res) {
                this.login_loading = false
                this.$Notice.error({title:'服务器异常，登陆失败'});
            })
        },
        automaticLogin(e){
            console.log(e.keyCode)
        }
    }
}
</script>

<style lang="postcss" scoped type="scss">
    .login-container{
        display:flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: calc(100%);
    & .bg-wrap{
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          position: relative;
      }
    & .card-wrap{
          position: absolute;
          right:100px;
          top:200px;
      }
    & .icon-cls{
          font-weight:bold;
          width:20px;
          font-size:18px;
      }
    }
</style>
